import { useRef, FC } from 'react';
import intl from 'react-intl-universal';
import { useSelector } from 'react-redux';
import { Typography } from '@getsynapse/design-system';
import { selectAllTaskBundles } from 'state/TasksBundle/tasksBundleSlice';
import { Option } from 'utils/customTypes';
import TaskBundlePicker from 'Molecules/TaskBundlePicker/TaskBundlePicker';
import { useElementWidth } from 'Hooks/useElementWidth';

interface ImportStepProps {
  onSelectTaskBundle: (bundle: Option) => void;
}

const ImportStep: FC<ImportStepProps> = ({ onSelectTaskBundle }) => {
  const containerElement = useRef<HTMLDivElement>(null);
  const taskBundleWidth = useElementWidth(containerElement);
  const taskBundles = useSelector(selectAllTaskBundles);

  return (
    <>
      <Typography>
        {intl.get('TASKS.IMPORT_TASKS_MODAL.DESCRIPTION')}
      </Typography>

      <div ref={containerElement}>
        <TaskBundlePicker
          required
          taskBundles={taskBundles}
          onSelectTaskBundle={onSelectTaskBundle}
          width={taskBundleWidth}
        />
      </div>
    </>
  );
};

export default ImportStep;
